module.exports = __webpack_public_path__ + "img/alto_logo.538d9f2e.png";